// 这里存放数据格式效验的工具函数
import t from "../i18n/t";
import commonAppStore from "@common/src/store/modules/app";

interface checkResult {
  success: boolean;
  msg: string;
}

/**
 * 判断一个值是否为NaN
 * @param {number | string} value
 * @return {boolean}
 */
export function myIsNaN(value) {
  if (typeof value !== "number" && typeof value !== "string") {
    return true;
  }
  if (typeof value === "string" && "" === value.trim()) {
    // 判断空格
    return true;
  }
  let n = Number(value);
  return n !== n;
}

// 密码规则
/**
 * @param {number | string} password
 * @return {object: Error}
 */
export function passwordRules(password) {
  const regex = /^\w{6,18}$/;
  if (!password) {
    return {
      success: false,
      msg: t("login.password-empty-tips")
    };
  }
  if (password.length < 6 || password.length > 18) {
    return {
      success: false,
      msg: t("v210930.password-contains-characters")
    };
  }
  if (!regex.test(password)) {
    return {
      success: false,
      msg: t("v210930.password-contain-only-digits")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

// 中国手机号规则
/**
 * @param {number | string} mobile
 * @return {object: Error}
 */
export function mobileRules(mobile, country = commonAppStore.state.country, canEmpty = false) {
  // v211030国际版版本暂时去掉校验
  // v2.8 根据地区区分
  if (canEmpty && !mobile) {
    return {
      success: true,
      msg: ""
    };
  }
  if (country === "china") {
    const regex = /^1[0-9]{10}$/;
    if (!mobile) {
      return {
        success: false,
        msg: t("v210930.Please-enter-your-mobile-phone-number")
      };
    }
    if (mobile.length !== 11) {
      return {
        success: false,
        msg: t("v210930.mobile-phone-number-contains-11-digits")
      };
    }
    if (!regex.test(mobile)) {
      return {
        success: false,
        msg: t("v210930.phone-number-format-is-incorrect")
      };
    }
    return {
      success: true,
      msg: ""
    };
  } else {
    return {
      success: true,
      msg: ""
    };
  }
}

// 邮箱规则
/**
 * @param {string} mail
 * @return {object: Error}
 */
export function mailRules(mail) {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!mail) {
    return {
      success: false,
      msg: t("v210930.The-mailbox-cannot-be-empty")
    };
  }
  if (!regex.test(mail)) {
    return {
      success: false,
      msg: t("v210930.mailbox-format-incorrect")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

/**
 * 价格规则
 * 可以为0
 * @param {number | string} price
 * @return {object: Error}
 */
export function priceRules(price) {
  const regex = /^[0-9]+(.[0-9]{1,2})?$/;
  price = String(price);
  if (!regex.test(price)) {
    return {
      success: false,
      msg: t("v210930.Please-enter-positive-value")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

/**金额校验:小数点后2位内 0.00格式，任意正整数，小数不超过2位,不能为0
 * 请改用 checkMoney 后续删除
 * @param {number | string} num
 */
export function verifyMoney(num, canZero = false) {
  if (canZero && num !== null && Number(num) === 0) {
    return true;
  }
  let patt = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
  if (patt.test(num)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 用户名规则
 * @param { string} username
 * @return {object: Error}
 */
export function usernameRules(price) {
  const regex = /^([0-9]|[a-z]|[A-Z]|_){6,18}$/;
  price = String(price);
  if (!regex.test(price)) {
    return {
      success: false,
      msg: t("v210930.user-name-consists-alphanumeric-underscores")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

/**
 * 验证正整数
 * @param {number | string} num
 * @return {boolean: result}
 */
export function isPositiveInteger(num) {
  const regex = /^\d+$/;
  if (regex.test(num) && num > 0) {
    return true;
  }
  return false;
}

/**
 * 里程规则 验证正整数 配合el-form
 * @param {number | string} num
 * @return {undefined}
 */
export function mileageRulesEl(val, callback, canEmpty = false) {
  if (canEmpty && !val) {
    // 可以为空
    return callback();
  }
  let match = isPositiveInteger(val);
  if (match) {
    callback();
  } else {
    callback(new Error(t("v210831.please-enter-a-integer")));
  }
}

/**
 * 零配件数量规则
 * 大于等于0 可以为小数，最多保留2位小数点
 * @param {number | string} quantity
 * @return {object: Error}
 */
export function partsQuantityRules(quantity, includeZero = true) {
  const regex = /^[0-9]+(.[0-9]{1,2})?$/;
  quantity = String(quantity);
  if (!regex.test(quantity)) {
    return {
      success: false,
      msg: t("v210930.number-parts-numerical-most-decimal")
    };
  } else if (!includeZero && Number(quantity) === 0) {
    return {
      success: false,
      msg: t("v213.the-number-of-spare-parts-should-than-0")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

/**
 * 工时正则：非负整数||0
 * @param {number | string} workHour
 * @return {object: Error}
 */
export function workHourRules(workHour) {
  if (Number(workHour) !== 0 && !isPositiveInteger(workHour)) {
    return {
      success: false,
      msg: t("v210930.Please-enter-positive-integer")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

// 身份证规则
/**
 * @param {string} id
 * @return {object: Error}
 */
export function checkIdentityId(id, country = commonAppStore.state.country) {
  const regex = /^([0-9]|[a-z]|[A-Z])*$/;
  id = String(id);
  if (country === "china") {
    if (id.length !== 15 && id.length !== 18) {
      return {
        success: false,
        msg: t("v213.the-length-of-id-card-is-18-digits")
      };
    }
    if (!regex.test(id)) {
      return {
        success: false,
        msg: t("v210930.id-number-consists-numbers-letters")
      };
    }
    return {
      success: true,
      msg: ""
    };
  }
  return {
    success: true,
    msg: ""
  };
}

// 社会信用代码（纳税人识别号）
/**
 * @param {string} id
 * @return {object: Error}
 */
export function checkSocialCreditCode(id) {
  const regex = /^([0-9]|[A-Z])*$/;
  id = String(id);
  if (id.length !== 15 && id.length !== 18) {
    return {
      success: false,
      msg: t("v213.the-length-of-social-credit-code-18-digits")
    };
  }
  if (!regex.test(id)) {
    return {
      success: false,
      msg: t("v213.the-social-credit-code-consists-of-capital-letters")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

// 社会信用代码（纳税人识别号）el-form
export function checkSocialCreditCodeEl(id, callback) {
  let match = checkSocialCreditCode(id);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

// 车牌号
/**
 * @param {string} code
 * @return {object: Error}
 */
export function checkPlateCode(code, country = commonAppStore.state.country) {
  // const regex = /^([0-9]|[a-z]|[A-Z])*$/;
  const minLenght = country === "china" ? 1 : 0;
  const minInputLenght = country === "china" ? 6 : 1;
  const maxInputLength = country === "china" ? 7 : 99;
  if (!code || code.length <= minLenght) {
    // 中国省会缩写占用一个长度
    return {
      success: false,
      msg: t("v210930.enter-license-plate-number")
    };
  }
  // 中国省会缩写占用一个长度
  const inputText = country === "china" ? code.substr(1) : code;
  if (inputText.length < minInputLenght || inputText.length > maxInputLength) {
    // 中国省会缩写占用一个长度
    return {
      success: false,
      msg: t("v213.platecode-check-msg", { min: minInputLenght, max: maxInputLength })
    };
  }
  return {
    success: true,
    msg: ""
  };
}

// 密码规则配合el-form使用
/**
 * @param {number | string} password
 * @param {Element:callback} callback
 */
export function passwordRulesEl(password, callback) {
  let match = passwordRules(password);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

// 手机规则配合el-form使用
/**
 * @param {number | string} mobile
 * @param {Element:callback} callback
 */
export function mobileRulesEl(mobile, callback, canEmpty = false, country = commonAppStore.state.country) {
  let match = mobileRules(mobile, country, canEmpty);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

// 邮箱规则配合el-form使用
/**
 * @param {number | string} mail
 * @param {Element:callback} callback
 */
export function mailRulesEl(mail, callback) {
  let match = mailRules(mail);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

// 价格配合el-form使用
/**
 * @param {number | string} price
 * @param {Element:callback} callback
 */
export function priceRulesEl(price, callback) {
  let match = priceRules(price);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

// 身份证号校验配合el-form使用
/**
 * @param {number | string} price
 * @param {Element:callback} callback
 */
export function identityIdRulesEl(id, callback, country = commonAppStore.state.country) {
  let match = checkIdentityId(id, country);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

// 身份证号校验配合el-form使用
/**
 * @param {number | string} plateCode
 * @param {Element:callback} callback
 */
export function plateCodeRuleEl(plateCode, callback, country = commonAppStore.state.country) {
  let match = checkPlateCode(plateCode, country);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

/**用户名
 * @param {number | string} username
 * @param {Element:callback} callback
 */
export function usernameRuleEl(username, callback) {
  let match = usernameRules(username);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

/**
 * 验证正整数和0
 * @param {number | string} num
 * @return {boolean: result}
 */
export function isPositiveIntegerZero(num) {
  const regex = /^\d+$/;
  if (regex.test(num) && num >= 0) {
    return true;
  }
  return false;
}

/**
 * 返回去除逗号的字符串
 * @param{string} num
 * @return {string}
 */
export function replaceComma(string) {
  return string.replace(/,/g, "");
}

/**
 * 一般编号规则：数字字母下划线组成
 * @param {number | string} generalNumber
 * @return {object: Error}
 */
export function generalNumberRules(generalNumber) {
  const regex = /^\w+$/;
  if (!regex.test(generalNumber)) {
    return {
      success: false,
      msg: t("v213.please-enter-alphanumeric-underline")
    };
  }
  return {
    success: true,
    msg: ""
  };
}
/**
 * 税率规则 0-99.9
 * @param {number | string} generalNumber
 * @return {object: Error}
 */
export function taxRateRules(val, canEmpty = false, canZero = true) {
  if (canEmpty && !val) {
    return {
      success: true
    };
  }

  val = String(val);
  let patt = /(^0$)|(^[1-9][0-9]*$)|(^0\.\d{1,2}$)|(^[1-9][0-9]*\.\d{1,2}$)/;
  if (patt.test(val)) {
    if (canZero && val !== null && Number(val) === 0) {
      return {
        success: true
      };
    }
    if (Number(val) >= 100) {
      return {
        success: false,
        msg: t("v270.value-type-with-tax-rate-less-than-100")
      };
    }
    return {
      success: true,
      msg: ""
    };
  } else {
    return {
      success: false,
      msg: t("v270.value-type-of-tax-rate-up-decimal-places")
    };
  }
}
/* 验证金额 0.00格式，任意正整数，小数不超过2位
 * @param {number} number
 * @param {number} canBeZero 是否可以为0
 * @return {boolean: result}
 */
export function checkMoney(number, canBeZero = true): checkResult {
  const isNum = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
  if (canBeZero && parseFloat(number) === 0) {
    return {
      success: true,
      msg: ""
    };
  }
  if (isNum.test(number)) {
    return {
      success: true,
      msg: ""
    };
  } else {
    return {
      success: false,
      msg: t("v213.please-enter-a-numeric-value-up-decimal-places")
    };
  }
}

// 税率配合el-form使用
/**
 * @param {number | string} taxRateRules
 * @param {Element:callback} callback
 */
export function taxRateRulesEl(val, callback, canEmpty = false, canZero = true) {
  let match = taxRateRules(val, canEmpty, canZero);
  console.log(match);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

export function checkMoneyEl(val, callback, canEmpty = false, canBeZero = true) {
  if (canEmpty && !val) {
    return callback();
  }
  let check = checkMoney(val, canBeZero);
  if (check.success) {
    callback();
  } else {
    console.log(444, val);
    callback(new Error(check.msg));
  }
}

/**
 * 验证仓库库位编号
 * @param {string} number
 * @return {result}
 */

export function shelfNumberRulesEl(val, callback, canEmpty = false) {
  if (canEmpty && !val) {
    return callback();
  }
  let match = generalNumberRules(val);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

/**
 * 验证百分比 0-100区间 格式同金额
 */
export function percentageRules(val, fieldName = "") {
  if (!checkMoney(val)) {
    return {
      success: false,
      msg: `${fieldName ? fieldName + ": " : ""}${t("v213.please-enter-a-numeric-value-up-decimal-places")}`
    };
  }
  if (Number(val) < 0 || Number(val) > 100) {
    return {
      success: false,
      msg: `${fieldName ? fieldName + ": " : ""}${t("v213.please-enter-positive-number-and-not-greater")}`
    };
  }
  return {
    success: true,
    msg: null
  };
}

/**
 * 零配件自定义编号规则
 *c @param code
 */
export function checkPartsCustomizeCode(code) {
  const reg = /^[A-z0-9_]{0,64}$/;
  const checkResult = reg.test(code);
  if (!checkResult) {
    return {
      success: false,
      msg: t("v216_g.parts-customize-no-rule-text")
    };
  }
  return {
    success: true,
    msg: "success"
  };
}

/**
 * 零配件自定义编号规则 El
 *c @param code
 */
export function checkPartsCustomizeCodeEl(val, callback, canEmpty = false) {
  if (canEmpty && !val) {
    return callback();
  }
  let match = checkPartsCustomizeCode(val);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}
